import AbstractRepository from './AbstractRepository';
import collect from 'collect.js';

interface ServicoFilters {
    grupoId?: number,
}

export default class ServicoRepository extends AbstractRepository {
    static resource = 'servico';

    /**
     * Resgata lista de Serviços disponíveis
     * 
     * @param filters Filtros para API
     * 
     * @return Collection<unknown>
     */
    public static async listar(filters: ServicoFilters = {}) {
        let response = await this.get(`${this.resource}`, filters);
        let lista = collect(response.dados);
        return lista;
    }
}
